/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
    shape, object, bool, string, func,
} from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
    Grid, FormControl, RadioGroup, Radio, FormControlLabel,
} from '@material-ui/core';
import TextFieldWrapper from '../../../../../pages/Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/TextFieldWrapper';
import styles from './InputValidationStyles';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

/* eslint-disable react/jsx-props-no-spreading */
const BGSInputField = ({
    classes, fieldInfo, formFieldState, getTextFieldProps, handleFieldChange, formState, handleFieldBlur,
}) => {
    const brand = useSelector(getBrand);
    const {
        id = '', name = '', labelName = '', colLength = 6, radioType = [], customTextArea = false, type = '', minLength = 3, maxLength = 50, maskInput, validateRule = '', rows = 5, customDateInput = false, groupName = '',
    } = fieldInfo;

    if (groupName) {
        return (
            <Grid item sm={colLength} lg={6} xs={12} className={`bgsInputElement mb-4 ${id}_element`}>
                <Grid className={`customInputValidation ${classes.customInputValidations} custom-${groupName}-field`}>
                    <FormControl fullWidth component="fieldset">
                        <legend>{labelName}</legend>
                        <RadioGroup row className="radio-shipping-address" defaultValue="no_delivery" onChange={handleFieldChange} role="radiogroup">
                            {radioType.map((data) => (
                                <Grid item sm={6} md={3} key={data?.id} classes={{ root: classes.radioRoot }}>
                                    <FormControlLabel
                                        label={data?.labelName}
                                        classes={{
                                            label: classes.radioLabelRoot,
                                        }}
                                        name={name}
                                        value={data?.value}
                                        labelPlacement="end"
                                        className={data?.labelClass}
                                        id={`label-${data?.id}`} // Add id here to associate it with Radio
                                        control={<Radio disableRipple size="small" role="radio" aria-labelledby={`label-${data?.id}`} />}
                                    />
                                </Grid>
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid item sm={colLength} lg={colLength} xs={12} className={`bgsInputElement mb-4 ${id}_element`}>
            <div className={`customInputValidation ${classes.customInputValidations} custom-${type}-field`}>
                <Grid className="position-relative">
                    <TextFieldWrapper
                        customTextArea={customTextArea}
                        customDateInput={customDateInput}
                        isPlants={brand?.code === 'PLA'}
                        min={minLength}
                        max={maxLength}
                        rows={rows}
                        label={labelName}
                        name={name}
                        maskInput={maskInput}
                        validateRule={validateRule}
                        inputType={type}
                        required={formFieldState?.[name]?.required}
                        flagError={formFieldState?.[name]?.flagError}
                        errorMessage={formFieldState?.[name]?.errorMessage}
                        variant="outlined"
                        val={formState[name]}
                        isInputFilled={handleFieldBlur}
                        setTextInputState={handleFieldChange}
                        returnFieldProps={getTextFieldProps}
                        isBorderColor={false}
                    />
                </Grid>
            </div>
        </Grid>
    );
};

BGSInputField.propTypes = {
    formState: shape({
        firstName: string.isRequired,
        lastName: string.isRequired,
        email: string.isRequired,
        message: string.isRequired,
        quantity: string.isRequired,
    }).isRequired,
    fieldInfo: shape({

    }).isRequired,
    formFieldState: shape({
        firstName: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        lastName: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        email: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        quantity: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        message: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        phone: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
        desiredProduct: shape({
            required: bool.isRequired,
            flagError: bool.isRequired,
            errorMessage: string.isRequired,
        }).isRequired,
    }).isRequired,
    getTextFieldProps: func.isRequired,
    handleFieldChange: func.isRequired,
    handleFieldBlur: func.isRequired,
    classes: object,
};

BGSInputField.defaultProps = {
    classes: {},
};

export default withStyles(styles)(BGSInputField);
